var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{staticClass:"form-radio",attrs:{"label-width":_vm.labelWidth,"label":_vm.label}},[_c('el-radio-group',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.input_value}},_vm._l((_vm.list),function(item){return _c('el-radio-button',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }